import { Component, inject } from '@angular/core';
import { Event, Router, NavigationStart, NavigationEnd, RouterModule } from '@angular/router';
import { PageLoaderComponent } from './layout/page-loader/page-loader.component';
import { SpinnerComponent } from '@shared/components/spinner/spinner.component';
import { default as moment, Moment } from 'moment/min/moment-with-locales';
import { CookieConsentComponent } from '@shared/components/cookie-consent/cookie-consent.component';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    imports: [
        RouterModule,
        PageLoaderComponent,
        SpinnerComponent,
        CookieConsentComponent,
    ],
})
export class AppComponent {
    private readonly _router = inject(Router);

    currentUrl!: string;

    constructor() {
        this.scrollToTop();
        this.overrideMomentLocale();
    }

    private scrollToTop(){
        this._router.events.subscribe({
            next: (routerEvent: Event) => {
                if (routerEvent instanceof NavigationStart) {
                    this.currentUrl = routerEvent.url.substring(routerEvent.url.lastIndexOf('/') + 1);
                }
                if (routerEvent instanceof NavigationEnd) {
                    /* empty */
                }
                window.scrollTo(0, 0);
            }
        });
    }

    private overrideMomentLocale(){
        moment.updateLocale('hu', {
            longDateFormat: {
                LTS: 'HH:mm:ss',
                LT: 'HH:mm',
                L: 'YYYY.MM.DD.',
                LL: 'YYYY. MMMM D.',
                LLL: 'YYYY. MMMM D., H:mm',
                LLLL: 'YYYY. MMMM D., dddd, H:mm',
            }
        });
    }
}
